import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Profilo } from '../models/';

@Injectable() /* Utilizzato per portare i dati del primo passaggio della registrazione al secondo passaggio */
export class RegistrazioneService {
  profilo: Profilo;
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/registrazione.service.ts